module.exports = __webpack_public_path__ + "static/media/user_funnel_analysis_en.91763a0b.png";